// store/actions/AuthActions.js
import {
    login,
    signUp,
    saveTokenInLocalStorage,
    logoutRequest
} from '../../services/AuthService';

export const SIGNUP_CONFIRMED_ACTION = '[auth] signup success';
export const SIGNUP_FAILED_ACTION = '[auth] signup failed';

export const LOGIN_CONFIRMED_ACTION = '[auth] login success';
export const LOGIN_FAILED_ACTION = '[auth] login failed';

export const LOGOUT_ACTION = '[auth] logout';

export const UPDATE_USER_PROFILE_ACTION = '[auth] update user profile';

export const LOADING_TOGGLE_ACTION = '[ui] loading toggle';
export const NAVTOGGLE = '[ui] nav toggle';


// ===================== SIGNUP =====================
export function signupAction(identifier, password, first_name, last_name) {
    return async (dispatch) => {

        dispatch(loadingToggleAction(true));

        try {
            const response = await signUp(identifier, password, first_name, last_name);

            const { accessToken, refreshToken, user } = response.data;

            const session = { accessToken, refreshToken, user };

            saveTokenInLocalStorage(session);

            dispatch(confirmedSignupAction(session));

            return { success: true };

        } catch (error) {

            dispatch(signupFailedAction(
                error?.response?.data?.message || "Signup failed"
            ));

            return { success: false };

        } finally {
            dispatch(loadingToggleAction(false));
        }
    };
}


// ===================== LOGIN =====================
export function loginAction(identifier, password) {
    return async (dispatch) => {

        dispatch(loadingToggleAction(true));

        try {
            const response = await login(identifier, password);

            const { accessToken, refreshToken, user } = response.data;

            const session = { accessToken, refreshToken, user };

            saveTokenInLocalStorage(session);

            dispatch(loginConfirmedAction(session));

            return { success: true };

        } catch (error) {

            dispatch(loginFailedAction(
                error?.response?.data?.message || "Invalid credentials"
            ));

            return { success: false };

        } finally {
            dispatch(loadingToggleAction(false));
        }
    };
}


// ===================== LOGOUT =====================
export function logoutAction() {
    return async (dispatch, getState) => {

        const refreshToken = getState()?.auth?.auth?.refreshToken;

        try {
            if (refreshToken) {
                await logoutRequest(refreshToken);
            }
        } catch (e) {
            // ignore backend error
        }

        localStorage.removeItem('userDetails');

        dispatch({ type: LOGOUT_ACTION });
    };
}

// ===================== UPDATE PROFILE (ex: nouvel avatar) =====================
// Fusionne des champs partiels (ex: { avatar, avatar_url }) dans l'utilisateur
// courant, en mémoire (Redux) et dans le localStorage, sans re-login.
export function updateUserProfileAction(partialUser) {
    return (dispatch, getState) => {
        const currentSession = getState()?.auth?.auth;
        if (!currentSession?.accessToken) return;

        const updatedSession = {
            ...currentSession,
            user: { ...currentSession.user, ...partialUser },
        };

        try {
            const stored = localStorage.getItem('userDetails');
            const parsed = stored ? JSON.parse(stored) : {};
            localStorage.setItem(
                'userDetails',
                JSON.stringify({ ...parsed, user: { ...parsed.user, ...partialUser } }),
            );
        } catch {
            // localStorage indisponible - la mise à jour reste au moins en mémoire
        }

        dispatch({ type: UPDATE_USER_PROFILE_ACTION, payload: updatedSession });
    };
}

// ===================== LOAD STORAGE =====================
export function loadUserFromStorage() {
    return (dispatch) => {

        const data = localStorage.getItem("userDetails");

        if (!data) {
            dispatch({ type: LOGOUT_ACTION });
            return;
        }

        try {
            const parsed = JSON.parse(data);

            if (!parsed?.accessToken) {
                dispatch({ type: LOGOUT_ACTION });
                return;
            }

            dispatch(loginConfirmedAction(parsed));

        } catch {
            dispatch({ type: LOGOUT_ACTION });
        }
    };
}


// ===================== ACTION CREATORS =====================
export const loginFailedAction = (message) => ({
    type: LOGIN_FAILED_ACTION,
    payload: message,
});

export const loginConfirmedAction = (data) => ({
    type: LOGIN_CONFIRMED_ACTION,
    payload: data,
});

export const confirmedSignupAction = (data) => ({
    type: SIGNUP_CONFIRMED_ACTION,
    payload: data,
});

export const signupFailedAction = (message) => ({
    type: SIGNUP_FAILED_ACTION,
    payload: message,
});

export const loadingToggleAction = (status) => ({
    type: LOADING_TOGGLE_ACTION,
    payload: status,
});

export const navtoggle = () => ({
    type: NAVTOGGLE
});